import { blogs } from "../../../text/blog/blogs";

import React, { useState } from "react";
import MenuPage from "../menu-page/menu-page";
import StyledHeader from "../../common/styled-header/styled-header";
import BodyText from "../../common/body-text/body-text";
import Button from "@/components/ui/button";

export const BlogContent = () => {
  function latestPost() {
    return blogs[blogs.length - 1];
  }

  return latestPost() ? (
    <>
      {/*{header()}*/}
      <div className={"flex flex-row justify-center"}>
        <StyledHeader
          header={"Developer Blog"}
          linkPath={"/blog"}
          subHeader={
            <>
              <p className={"font-sans"}>{latestPost().title}</p>
              <p className={"font-sans"}>{latestPost().author}</p>
            </>
          }
        />
        {/*<div className={"fake-button bg-gray-med p-2 w-3/4 justify-center"}>*/}
        {/*    <h3 className={"font-comic mt-2 underline"}>{latestPost().title}</h3>*/}
        {/*    <h4 className={"font-comic"}>{latestPost().author}</h4>*/}
        {/*</div>*/}
      </div>

      <BodyText>{latestPost().content}</BodyText>
    </>
  ) : (
    <></>
  );
};

const Blog = () => {
  const pageSize = 5;

  const [page, setPage] = useState(0);

  function posts() {
    return blogs
      .slice(-1 - (page + 1) * pageSize, -1 - page * pageSize)
      .reverse();
  }

  function handlePrevious() {
    setPage((prevState) => Math.max(0, prevState - 1));
  }

  function handleNext() {
    setPage((prevState) =>
      Math.min(Math.floor((blogs.length - 1) / pageSize), prevState + 1)
    );
  }

  function footer() {
    return (
      <div className={"flex grow space-x-1 justify-end"}>
        <Button disabled={page === 0} onClick={handlePrevious}>
          previous
        </Button>

        <Button
          disabled={page === Math.floor((blogs.length - 1) / pageSize)}
          onClick={handleNext}
        >
          next
        </Button>
      </div>
    );
  }

  return (
    <MenuPage
      subHeaders={["news from the dev team"]}
      titles={["blog"]}
      footerJsx={footer()}
    >
      <div
        className={
          "p-4 font-comic divide-y divide-gray-200 space-y-8 [&_p]:normal-case [&_p]:font-comic"
        }
      >
        {posts().map((p) => (
          <div>
            <StyledHeader header={p.title} subHeader={p.author} />
            <BodyText>{p.content}</BodyText>
          </div>
        ))}
      </div>
    </MenuPage>
  );
};

export default Blog;
